import { useEffect } from 'react';

/**
 * Locks page scrolling while the mobile menu is open.
 * Side effect: sets `document.body.style.overflow` to `hidden`, and back to
 * `auto` when closed or unmounted. Admin modals lock scroll through
 * utils/scrollLock instead, so don't run both at once.
 * @param {boolean} isMenuOpen
 */
const useNoScroll = (isMenuOpen) => {
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);
};

export default useNoScroll;
